import { Component} from '@angular/core';

@Component({
    selector: 'campaign-main',
    templateUrl: './campaign-main.tmpl.html'
})

export class CampaignMain {
    editMode: boolean = null; 

    public setVal(val:boolean) {
        this.editMode = val;  
    }
}
  